var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:_vm.validityStatusMap[_vm.validity].cssClass},[_vm._v(_vm._s(_vm.validityStatusMap[_vm.validity].text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }